import { type Spidr } from '@rtkwlf/track-public';
export const sortExpirationRows = (spidrA: Spidr, spidrB: Spidr) => {
  const aExpiry = spidrA.expiryDate?.getTime();
  const bExpiry = spidrB.expiryDate?.getTime();
  return sortRows(spidrA, spidrB, aExpiry, bExpiry);
};
export const expiringStates = ['Delivered', 'Complete'];

const sortRows = (
  spidrA: Spidr,
  spidrB: Spidr,
  aExpiry: number | undefined,
  bExpiry: number | undefined,
) => {
  const aState = spidrA.state;
  const bState = spidrB.state;
  const aDoesExpire = spidrA.blueprint.doesExpire;
  const bDoesExpire = spidrB.blueprint.doesExpire;

  // Sort on states that have expiry.
  if (expiringStates.includes(aState) && !expiringStates.includes(bState)) {
    return -1;
  } else if (
    !expiringStates.includes(aState) &&
    expiringStates.includes(bState)
  ) {
    return 1;
  }

  // Sort on Spidrs that have a set expiration.
  if (aDoesExpire && !bDoesExpire) {
    return -1;
  } else if (!aDoesExpire && bDoesExpire) {
    return 1;
  }

  // Sort on the Spidr expiry date.
  if (aExpiry && bExpiry && aExpiry < bExpiry) {
    return -1;
  } else if (aExpiry && bExpiry && aExpiry > bExpiry) {
    return 1;
  }

  return 0;
};
